<template>
	<div
		class="tool-tip__wrapper grid"
		:class="tooltipWrapperClass">
		<div
			@mouseenter="hover ? toggleToolTip() : null"
			@mouseleave="hover ? toggleToolTip() : null"
			class="tool-tip__wrapper-inner">
			<transition name="fade">
				<div
					class="tool-tip"
					:style="tooltipStyle"
					title="Sluiten"
					v-html="unmet ? '<span>Deze optie is niet mogelijk in uw huidige configuratie.</span>' : formatContent"
					ref="tooltip"/>
			</transition>
			<template
				v-if="hover">
				<slot>
					<span
						@click.stop="hover ? null : toggleToolTip()"
						class="tool-tip__label"
						:class="toolTipClass"
						title="Info">i</span>
				</slot>
			</template>
			<template
				v-else>
				<slot>
					<span
						class="tool-tip__label"
						:class="toolTipClass"
						title="Info">i</span>
				</slot>
			</template>
		</div>
	</div>
</template>

<script>
import {EventBus} from "@/store/index.js";

export default {
	name: "ToolTip",
	props: {
		content: {
			type: String,
			default: ""
		},
		closeOthers: {
			type: Boolean,
			default: false
		},
		type: {
			type: String,
			default: ""
		},
		unmet: {
			type: Boolean,
			default: false
		},
		absolute: {
			type: Boolean,
			default: true
		},
		tooltipWrapperClassName: {
			type: String,
			default: null
		},
		hover: {
			type: Boolean,
			default: false
		}
	},
	data () {
		return {
			active: false,
			transform: 0,
			style: {}
		};
	},
	computed: {
		tooltipWrapperClass () {
			const classList = [];
			const supportedTypes = [
				"list",
				"rounded",
				"absolute",
				"relative"
			];

			const typeClass = type => supportedTypes.includes(type)
				? `tool-tip__wrapper--${type}`
				: "";

			if (this.tooltipWrapperClassName) {
				classList.push(this.tooltipWrapperClassName);
			}
			if (this.active) {
				classList.push("tool-tip__wrapper--active");
			}
			if (this.type) {
				classList.push(typeClass(this.type));
			}

			return classList;
		},
		toolTipClass () {
			const classList = [];
			if (this.absolute) {
				classList.push("tool-tip__label--absolute");
			}
			if (this.unmet) {
				classList.push("tool-tip__label--unmet");
			}
			if (this.active) {
				classList.push("tool-tip__label--active");
			}
			return classList;
		},
		tooltipStyle () {
			return this.style;
		},
		formatContent () {
			const contentArray = this.content.split(" ");
			let count = 0;
			const wrapAt = 60;

			contentArray.map((item, index) => {
				count += item.length;

				if (count > wrapAt) {
					contentArray.splice(index - 1, 0, "</span><span>");
					count = 0;
				}
			});
			return "<span>" + contentArray.join(" ") + "</span>";
		},
		configuratorBoundingRect () {
			return this.$store.getters.getBoundingRect;
		}
	},
	methods: {
		toggleToolTip () {
			if (this.closeOthers) {
				EventBus.$emit("closeOtherTooltips");
			}
			this.active = !this.active;
		},
		setTooltipStyle (element) {
			const holder = this.$el.closest(".configurator__holder");
			if (!holder) return;
			const holderRect = holder.getBoundingClientRect();
			if (holderRect.width === 0) return;
			const configLeft = Math.max(holderRect.left, 0);
			const configRight = Math.min(holderRect.right, window.innerWidth);

			const halfWidth = element.getBoundingClientRect().width / 2;
			element.style.transform = "translateX(" + -halfWidth + "px)";
			element.style.transitionProperty = "none";

			const popupRect = element.getBoundingClientRect();
			const overflowRight = popupRect.right - configRight;
			const overflowLeft = configLeft - popupRect.left;
			let translate = -halfWidth;
			if (overflowRight > 0) {
				translate -= overflowRight;
			} else if (overflowLeft > 0) {
				translate += overflowLeft;
			}

			this.transform = translate;
			this.style = {
				visibility: this.active ? "visible" : "hidden",
				pointerEvents: this.active ? "all" : "none",
				transform: "translateX(" + translate + "px)",
				transitionProperty: "none"
			};
		}
	},
	mounted () {
		EventBus.$on("closeOtherTooltips", e => {
			this.active = false;
		});

		this.style = {
			visibility: "hidden",
			pointerEvents: "none"
		};
	},
	watch: {
		active () {
			this.setTooltipStyle(this.$refs.tooltip);
		},
		configuratorBoundingRect () {
			if (this.active) {
				this.setTooltipStyle(this.$refs.tooltip);
			}
		}
	}
};
</script>

<style lang="scss">
	.tool-tip {
		background: rgba(40, 40, 40, 0.95);
		position: absolute;
		padding: 12px;
		font-size: 1.1rem;
		border-radius: 4px;
		bottom: 100%;
		cursor: pointer;
		margin-bottom: 9px;
		color: white;
		box-shadow: 6px 7px 6px -5px rgba(0, 0, 0, 0.4);
		left: 0;
		white-space: normal;
		max-width: 280px;
		width: max-content;
		z-index: 100;
		transition-property: none;
		transition-timing-function: ease;
		transition-duration: 333ms;

		span {
			display: block;
			line-height: 1.4
		}
	}
	.indicator-container .tool-tip__wrapper:last-child {
		border-bottom-right-radius: 6px;
		border-top-right-radius: 0;
	}

	.tool-tip__wrapper {
		position: relative;
		border-top-left-radius: 4px;
		border-top-left-radius: 4px;

		&--list .tool-tip__label {
            top: auto;
            border-width: 1px;
            display: inline-flex;
            height: 20px;
            width: 20px;
            font-size: 14px;
        }

		&:not(&--list) {
			position: absolute;
			top: 0;
			left: 0;
			right: 0;
			bottom: 0;

			.tool-tip {
				margin-bottom: 0px;
			}
		}

		&:not(&--relative) .tool-tip__wrapper-inner {
			top: 0;
			position: absolute;
		}

		&--rounded .tool-tip__label {
			top: 0;
			right: 0;
		}

		&#{&}--extra-delivery-days {
			top: 14px;
			right: 25px;
		}

		&#{&}--relative {
			position: relative;
		}

		&#{&}--orientation .tool-tip {
			margin-bottom: 36px;
			left: 12px;
		}

		&#{&}--offset .tool-tip {
			margin-bottom: 10px;
			left: 12px;
		}

		&--offset {
			background: var(--cfg-info);
		}

		&--sustainable {
			background: var(--cfg-success);
		}

		&--absolute {
			position: absolute;
			top: 0;
			left: 0;
		}
	}

	.tool-tip__label {
		&--unmet {
			background: #ee8b8c;
		}

		&:before {
			opacity: 0;
			visibility: hidden;
		}

		&--active:before {
			opacity: 1;
			visibility: visible;
		}
	}

	@media screen and (max-width: 1000px) {
		.tool-tip__wrapper.tool-tip__wrapper--orientation .tool-tip {
			margin-bottom: 26px;
			left: 12px;
		}
	}

	@media screen and (max-width: 725px) {
		.tool-tip__wrapper.tool-tip__wrapper--table {
			margin-top: 11px;
			margin-right: 11px;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/element/tooltip.vue